var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_17",
    "data-name": "Rounded Rectangle 17",
    className: "cls-1",
    d: "M7.647,4.5H33.353a3,3,0,0,1,3,3v2a3,3,0,0,1-3,3H7.647a3,3,0,0,1-3-3v-2A3,3,0,0,1,7.647,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_17_copy",
    "data-name": "Rounded Rectangle 17 copy",
    className: "cls-1",
    d: "M7.486,20.6h35a3,3,0,0,1,3,3v1.983a3,3,0,0,1-3,3h-35a3,3,0,0,1-3-3V23.6A3,3,0,0,1,7.486,20.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_17_copy_2",
    "data-name": "Rounded Rectangle 17 copy 2",
    className: "cls-1",
    d: "M6.819,36.5H23.181a3,3,0,0,1,3,3V41.5a3,3,0,0,1-3,3H6.819a3,3,0,0,1-3-3V39.5A3,3,0,0,1,6.819,36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.525,38l7.858-2,12.049,1L26,39,25.48,43l-4.191,2H5.572L4,41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ebddd4b6759fff2c0903a120d77c7ce6.svg";
export { ForwardRef as ReactComponent };